export default __webpack_public_path__ + "media/images/theme/bg_dark-147cdf17ee4c7bb003392b8154c94f58.png";